import React, { useEffect, useState } from "react";
import { Modal, Typography, Button, Grid, List, ListItem, Collapse, styled } from "@mui/material";
import Box from '@mui/material/Box';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import FetchVerbruikEstimate from "./FetchVerbruikEstimate";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import HomeIcon from '@mui/icons-material/Home'; // Standaard icoon voor huis
import PeopleIcon from '@mui/icons-material/People'; // Standaard icoon voor personen

export default function ParticulierVerbruikInschatterBoxStep1({
    sethouseholdSize,
    householdSize
}) {
    // ... Logica voor het bepalen van het type woning

    const CustomIcon = ({ iconClass }) => (
        <div className = "icon-text-wrapper">
        <div className={iconClass}></div>
        </div>
    );

    const FullWidthButton = styled(Button)(({ theme }) => ({
        width: 'calc(100% - ' + theme.spacing(2) + ')', // Trek de totale padding af van de breedte
        margin: theme.spacing(1), // Set een kleine margin voor elke kant
      }));

    useEffect(() => {


        if (householdSize) {
            handleHouseholdSizeChange(householdSize);
        } else {
            sethouseholdSize('1 persoon');
        }


    }, [householdSize]);




    const handleBuildingTypeChange = (type) => {
        setSelectedBuildingType(type);
    };

    const handleHouseholdSizeChange = (size) => {
        sethouseholdSize(size);
    };

    return (
        <Box padding={2}>

      <Typography variant="h6" color="#007681">
        En uit hoeveel personen bestaat je huishouden?
      </Typography>

      <List>
        {[
          { size: '1 persoon', Icon: PeopleIcon },
          { size: '2 personen', Icon: PeopleIcon },
          { size: '3 personen', Icon: PeopleIcon },
          { size: '4 personen', Icon: PeopleIcon },
          { size: '5 of meer', Icon: PeopleIcon }
        ].map(({ size, Icon }) => (
          <ListItem key={size}>
            <FullWidthButton
              startIcon={<CustomIcon iconClass={`icon-as-${size.split(' ')[0]}pers icon-size`} />}
              variant={householdSize === size ? "contained" : "outlined"}
              onClick={() => handleHouseholdSizeChange(size)}
            >
              {size}
            </FullWidthButton>
          </ListItem>
        ))}
      </List>
    </Box>
    );
}